module.exports = __webpack_public_path__ + "img/syukyaku-top-pa002.1ae15cdd.png";